import React from 'react';
export function AnnouncementBar() {
  return <div className="bg-gold-dark text-dark font-semibold text-center py-3 px-4 text-sm md:text-base tracking-wide sticky top-0 z-50 shadow-md" data-id="element-13">
      ATTENTION: Special Offer available for a limited time. 75% Discount active
      today.
    </div>;
}